import { createContext } from "react";

import { IGenericUploadRowConflict } from "@ryde/shared";

export interface IGenericUploadRowConflictsContext {
  conflicts: IGenericUploadRowConflict[] | null;
}

export const GenericUploadRowConflictsContext =
  createContext<IGenericUploadRowConflictsContext>({
    conflicts: null,
  });
